var app = angular.module('leonardo');

var TrustUrlFilter = function ($sce) {
    return function(url) {
      return $sce.trustAsResourceUrl(url);
    };
};
app.filter('trusturl', ['$sce', TrustUrlFilter]);